module.exports = __webpack_public_path__ + "../resources/img/ic_incomplete_number_3.6495f88e.svg";